module.exports = __webpack_public_path__ + "assets/chevron-down-sharp.9ad4b3db.svg";